import React from "react"

// components
import ModalForm from "components/Modal/ModalForm/ModalForm"
import TagsField from "components/TagsField/TagsField"
import { Select, TextInput } from "components-design-system"

// apis
import { useGetActivityTypes } from "api/hooks/activities/useActivitiesApi"

// styles
import "./CreateActivityModal.scss"

// Ant Design
import { Form } from "antd"

const CreateActivityModal = ({ open, onCancel, onCreateActivity, isLoading, activities }) => {
  const { data: activityTypes = [] } = useGetActivityTypes()
  const [form] = Form.useForm()

  //  Generates an array of options for completed activities.
  const getCompletedActivityOptions = (activities, activityTypes) => {
    const activityMap = activities.reduce((map, activity) => {
      map[activity.project_title] = activity
      return map
    }, {})
    return (Array.isArray(activityTypes) ? activityTypes : [])
      .filter((type) => {
        if (activityMap[type.title]) {
          const activity = activityMap[type.title]
          return activity.progress_status === "completed"
        }
        return true
      })
      .map((item) => ({
        label: item.title,
        value: item.title,
      }))
  }

  const onCloseModal = () => {
    onCancel()
    form.resetFields()
  }

  const onSubmitModal = (values) => {
    onCreateActivity(values)
    form.resetFields()
  }

  return (
    <ModalForm
      modalProps={{
        open,
        className: "create-activity-modal-container",
        title: "Create Activity",
        onCancel: onCloseModal,
        okText: "Create",
        confirmLoading: isLoading,
      }}
      formProps={{
        form,
        layout: "vertical",
        className: "form-container",
        onFinish: onSubmitModal,
        initialValues: {
          project_type_id: null,
          comment_text: "",
        },
        disabled: isLoading,
      }}
    >
      <div className="form-container">
        <Form.Item
          label="Activity Types"
          name="project_type_id"
          className="full"
          rules={[{ required: true }]}
        >
          <Select
            className="field-item"
            allowClear={true}
            options={getCompletedActivityOptions(activities, activityTypes)}
          />
        </Form.Item>
        <Form.Item
          label="Comment"
          name="comment_text"
          className="full"
        >
          <TextInput type="textarea" />
        </Form.Item>
        <Form.Item
          label="Tags"
          name="tags"
          className="full"
          extra="Assigning labels allows for easier filtering and categorization of comments"
        >
          <TagsField />
        </Form.Item>
      </div>
    </ModalForm>
  )
}

export default CreateActivityModal
